/*
 * 横展開する場合はこのファイルをコピーし、タイトル固有のフォームがあれば調整してください
*/
import {computed, ref} from "vue";

// フォームのフォーマットとなるコンポーネント
import SelectFormComponent from "./components/SelectForm.vue";
import FreeTextComponent from "./components/FreeText.vue";
import SendComponent from "./components/Send.vue";
import RejectComponent from "./components/Reject.vue";
import ReissueComponent from "./components/Reissue.vue";
import SendWithBillingDetailSupportComponent from "./components/SendWithBillingDetailSupport.vue";

export default function magicianwizPages(inputValues, index) {
    const INPUT_KEY_SHOW_NAME_NICK_NAME = 'ユーザー名';
    const INPUT_KEY_SHOW_NAME_RANK = 'レベル';
    const INPUT_KEY_SHOW_NAME_START_DATE = 'ゲームを開始した日';
    const INPUT_KEY_SHOW_NAME_LAST_LOGIN_DATE = '最後にログインした日';
    const INPUT_KEY_SHOW_NAME_EMAIL = '登録されたメールアドレス';
    const INPUT_KEY_SHOW_NAME_BIRTHDAY = 'ゲーム内で登録した生年月';
    const INPUT_KEY_SHOW_NAME_SECRET_QUESTION = '登録された秘密の質問';
    const INPUT_KEY_SHOW_NAME_SECRET_ANSWER = '秘密の質問の答え';
    const INPUT_KEY_SHOW_NAME_DEVICE = '最終プレイ時に利用していた機種名';
    const INPUT_KEY_SHOW_NAME_CHARACTER = 'カード名';
    const INPUT_KEY_SHOW_NAME_PLAYER_NAME = 'プレイヤー名';
    const INPUT_KEY_SHOW_NAME_JOB = 'レベル';
    const INPUT_KEY_SHOW_NAME_GOLD = '所持クリスタル数';
    const INPUT_KEY_SHOW_NAME_CHARACTER_ON_MY_PAGE = 'マイページに設定しているカード名';
    const INPUT_KEY_SHOW_NAME_FINALLY_USES_GOLD = '最後にクリスタルを消費した際の用途';
    const INPUT_KEY_SHOW_NAME_PAYMENT_INFO = '購入内容';
    const INPUT_KEY_SHOW_NAME_PAYMENT_DATE = '購入日';
    const INPUT_KEY_SHOW_NAME_ORDER_NUMBER = '注文番号';

    const TOP_PAGE_INDEX = 0; //topページ
    const IS_LOGIN_PAGE_INDEX = 1; // ログインできるか
    const CONTACT_FROM_GAME_INDEX = 2; // 問い合わせ誘導
    const REGISTRATION_CASE_INDEX = 3; // 登録方法について
    const IS_REMEMBER_EMAIL_INDEX = 4; // メールアドレスを覚えているか
    const IS_REMEMBER_PASSWORD_INDEX = 5; // パスワードを覚えているか
    const IS_RECEIVE_EMAIL_INDEX = 6; // メールを受信できるか
    const SUPPORT_RECOVERY_EMAIL_INDEX = 7; // メールでの復旧方法
    const SUPPORT_RECOVERY_GOOGLE_INDEX = 8; // Googleでの復旧方法
    const SUPPORT_RECOVERY_APPLE_INDEX = 9; // Appleでの復旧方法
    const SUPPORT_RECOVERY_LINE_INDEX = 10; // LINEでの復旧方法
    const SUPPORT_RECOVERY_FACEBOOK_INDEX = 11; // FaceBookでの復旧方法
    const SUPPORT_RECOVERY_PASSWORD_REISSUE_INDEX = 12; // パスワード再発行
    const IS_PAY_INDEX = 13; // 課金について
    const STORE_INFO_INDEX = 14; // ストア情報
    const IS_OWN_DEVICE_INDEX = 15; // 端末を持っているか
    const BILLING_DETAIL_APPLE_INDEX = 16; // Appleの購入明細
    const BILLING_DETAIL_AMAZON_INDEX = 17; // Amazonの購入明細
    const BILLING_DETAIL_GOOGLE_INDEX = 18; // Googleの購入明細
    const BASIC_INFO1_INDEX = 19; // 基本情報1
    const BASIC_INFO2_INDEX = 20; // 基本情報2
    const APPLE_OR_AMAZON_CONFIRM_INDEX =  21; // AppleかAmazonの確認
    const APPLE_OR_AMAZON_SEND_MAIL_INDEX = 22; // AppleかAmazonのメール送信
    const SEND_MAIL_INDEX = 23; // メール送信
    const PLAY_INFO1_INDEX = 24; // プレイ情報1
    const PLAY_INFO2_INDEX = 25; // プレイ情報2
    const PLAY_INFO3_INDEX = 26; // プレイ情報3
    const PLAY_INFO4_INDEX = 27; // プレイ情報4
    const REJECT_INDEX = 28; // お断り
    const BILLING_DETAIL_OFFICIAL_STORE_INDEX = 29; // 公式ストアの購入明細

    //課金ストア
    const STORE_OFFICIAL = '公式ストア';
    const STORE_GOOGLE = 'Google';
    const STORE_APPLE = 'Apple';
    const STORE_AMAZON = 'Amazon';

    const REISSUE_MAIL_ADDRESS = 'quizwiz-password@colopl.jp';
    const CONTACT_MAIL_ADDRESS = 'quizwiz@colopl.jp';

    // 質問文
    const IS_LOGIN_PAGE_TEXT = '復旧希望のゲームアカウントにログインはできますか。';
    const CONTACT_FROM_GAME_TEXT = '次の手順にて、お問い合わせフォームよりご連絡ください。';
    const IS_OWN_DEVICE_TEXT = '復旧希望のアカウントでログインしたことがある端末は所有していますか。';
    const IS_REMEMBER_EMAIL_TEXT = '登録したメールアドレスは覚えていますか。';
    const IS_REMEMBER_PASSWORD_TEXT = '登録したパスワードは覚えていますか。';
    const IS_RECEIVE_EMAIL_TEXT = '登録したメールアドレスでメールの送受信はできますか。';
    const PASSWORD_REISSUE_TEXT = '空メールを送信してください。\n' + '登録メールアドレス宛てに新たなパスワードが送信されます。\n';
    const IS_PAY_TEXT = 'クリスタルやデッキを購入されたことはありますか。';
    const STORE_INFO_TEXT = 'どのストアから購入されましたか。';
    const LAST_PLAY_DEVICE_TEXT = '最終プレイ時に利用していた機種名';
    const REGISTRATION_CASE_TEXT = 'どの方法で引き継ぎ用のアカウント登録を行われましたか。';
    const SUPPORT_HOW_TO_RECOVERY_TEXT = '次の手順にて、ゲームデータを復旧してください。';
    const BASIC_INFO_TEXT = '復旧希望のアカウントに関する情報をご入力ください。';
    const PLAY_INFO_TEXT = '復旧希望のアカウントに関する情報をご入力ください。';
    const BILLING_NOTICE_TEXT = '購入時の明細が確認できるスクリーンショットをご準備ください。'
    const BILLING_DETAIL_TEXT = '注文履歴の情報をご入力ください。';
    const SEND_MAIL_TEXT = '以下の内容で復旧を依頼してよろしいですか。';
    const ITEM_PURCHASE_DETAILS = 'クリスタルまたはデッキの購入明細';
    const AMAZON_OR_APPLE_SEND_TEXT = '以下の「メーラーを起動する」を選択するとメール送信画面が起動します。\n' +
        'ご準備いただいた「' + ITEM_PURCHASE_DETAILS + '」を\n' +
        '確認できるスクリーンショットをメールに添付して送信してください。\n' +
        '※購入明細が確認できると、アカウント復旧のご案内がスムーズに行えます';
    const PROJECT_NAME = 'クイズRPG 魔法使いと黒猫のウィズ';

    // 購入明細の案内文
    const BILLING_DETAIL_OFFICIAL_STORE_HTML = '「<span style="color: red">サービス名（アプリ名）</span>」「<span style="color: red">購入日</span>」「<span style="color: red">購入金額</span>」の3点が確認できる明細画面のスクリーンショットを撮影してください。\n' +
    '\n' +
    '※購入履歴が複数ある場合は、それらが確認できるスクリーンショットも複数ご用意いただくことで、スムーズにアカウント復旧のご案内を行うことができます\n';

    const BILLING_DETAIL_APPLE_HTML = '以下の手順で、' + PROJECT_NAME +'の購入履歴が確認できるスクリーンショットを撮影してください。\n' +
        '\n' + '<span style="border: 1px solid black; padding: 10px; display: block;">' +
        '1. <a href="https://reportaproblem.apple.com" target=”_blank”>reportaproblem.apple.com</a>にアクセスし、Appleアカウントでサインインする\n' +
        '\n' +
        '2. ' + PROJECT_NAME + 'の購入履歴（商品名/購入日/価格）が表示されている画面のスクリーンショットを撮影する\n' +
        '\n' + '</span>\n' +
        '※購入履歴が複数ある場合は、それらが確認できるスクリーンショットも複数ご用意いただくことで、スムーズにアカウント復旧のご案内を行うことができます\n';

    const BILLING_DETAIL_AMAZON_HTML = '以下の手順で、' + PROJECT_NAME + 'の購入履歴が確認できるスクリーンショットを撮影してください。\n' +
        '\n' + '<span style="border: 1px solid black; padding: 10px; display: block;">' +
        '1. Amazonの<a href="https://www.amazon.co.jp/ap/signin?openid.pape.max_auth_age=0&openid.return_to=https%3A%2F%2Fwww.amazon.co.jp%2Fyour-orders%2Forders%3F_encoding%3DUTF8%26%252AVersion%252A%3D1%26%252Aentries%252A%3D0&openid.identity=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.assoc_handle=amzn_retail_yourorders_jp&openid.mode=checkid_setup&language=ja_JP&openid.claimed_id=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.ns=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0" target=”_blank”>注文履歴ページ</a>にアクセスする\n' +
        '\n' +
        '2. ' + PROJECT_NAME + 'の購入履歴（商品名/購入日/価格）が表示されている画面のスクリーンショットを撮影する\n' +
        '\n' + '</span>\n' +
        '※購入履歴が複数ある場合は、それらが確認できるスクリーンショットも複数ご用意いただくことで、スムーズにアカウント復旧のご案内を行うことができます\n';


    // ページ遷移
    const YES_TEXT = 'はい';
    const NO_TEXT = 'いいえ';
    const TOP_TEXT = 'topに戻る';
    const CONTINUE_TEXT = '進む';

    // 登録方法
    const REGISTRATION_SELECTION_EMAIL = 'クイズアカウント';
    const REGISTRATION_SELECTION_GOOGLE = 'Google アカウント';
    const REGISTRATION_SELECTION_APPLE = 'Apple アカウント';
    const REGISTRATION_SELECTION_UNKNOWN = '登録していない\n覚えていない';

    // 基本情報の案内文
    const PLAY_INFO1_MESSAGE = "■所持キャラカード\n" +
        "・ガチャから入手したキャラカードが対象です\n" +
        "・カード名およびレベルをご入力ください\n" +
        "・リーダーに設定していないカードをご入力ください\n" + 
        "・できる限り3つまでご入力ください\n" +
        "・覚えていない場合は未入力のまま「進む」を選択してください";

    const PLAY_INFO2_MESSAGE =  "■フォローしていたプレイヤー名\n" +
        "・できる限り3つまでご入力ください\n" +
        "・覚えていない場合は未入力のまま「進む」を選択してください";

    // 情報不足時の案内文
    const REJECT_MESSAGE =  "恐れ入りますが、ご入力いただいた情報が不足しているため、\n" +
        "アカウントの復旧についてご案内をすることができません。\n" +
        "\n" +
        "以下の項目について、未入力の場合は\n" +
        "お心当たりがないか、あらためてご確認ください。\n" +
        "\n" +
        "・所持キャラカード（3つまで入力）\n" +
        "・フォローしていたプレイヤー名（3つまで入力）\n" +
        "・所持クリスタル数\n" +
        "・マイページに設定しているカード名\n" +
        "・最後にクリスタルを消費した際の用途\n" +
        "・最終プレイ時に利用していた機種名\n"

    // 秘密の質問
    const secretQuestionSelections = [
        {'text': '母の旧姓は？'},
        {'text': '子供の頃の親友の名前は？'},
        {'text': '小学校の先生の名前は？'},
        {'text': '自動車のナンバーは？'}
    ];

    const INPUT_NICK_NAME_NOTICE = '※心当たりが複数ある場合は、すべてご入力ください。';
    const INPUT_EMAIL_NOTICE = '※心当たりが複数ある場合は、すべてご入力ください。';

    // 基本情報の入力項目
    const basicInfo1Items = [
        {
            'placeHolder': 'クロネコ',
            'name': INPUT_KEY_SHOW_NAME_NICK_NAME,
            'notice': INPUT_NICK_NAME_NOTICE
        },
        {
            'placeHolder': '397',
            'name': INPUT_KEY_SHOW_NAME_RANK
        },
        {
            'placeHolder': '2018/7/14',
            'name': INPUT_KEY_SHOW_NAME_START_DATE
        },
        {
            'placeHolder': '2023/3/5',
            'name': INPUT_KEY_SHOW_NAME_LAST_LOGIN_DATE
        }
    ];
    const basicInfo2Items = [
        {
            'name': INPUT_KEY_SHOW_NAME_EMAIL,
            'notice': INPUT_EMAIL_NOTICE
        },
        {
            'name': INPUT_KEY_SHOW_NAME_BIRTHDAY,
            'placeHolder': '1990年 3月',
        },
        {
            'groups' : [
                {
                    'name': INPUT_KEY_SHOW_NAME_SECRET_QUESTION,
                    'selections': secretQuestionSelections,
                },
                {
                    'name': INPUT_KEY_SHOW_NAME_SECRET_ANSWER,
                }
            ],
            'groupKey': 'secretQuestion',
            'groupDescription' : '「登録した秘密の質問」に複数お心当たりがある場合は、\n' +
                'こちらから追加入力してください（3つまで入力可）\n',
            'currentLoopCount' : ref(1),
            'maxLoopCount' : 3,
        },
    ];

    const CHARACTER_LOOP_COUNT = 3;
    const JOB_LOOP_COUNT = 3;
    const PLAYER_NAME_LOOP_COUNT = 3;

    // プレイ状況の入力項目
    const playInfo1Items = [
        {
            'name': INPUT_KEY_SHOW_NAME_CHARACTER,
            'loopCount' : CHARACTER_LOOP_COUNT
        },
        {
            'name': INPUT_KEY_SHOW_NAME_JOB,
            'loopCount' : JOB_LOOP_COUNT
        },
    ];
    const playInfo2Items = [
        {
            'name': INPUT_KEY_SHOW_NAME_PLAYER_NAME,
            'loopCount' : PLAYER_NAME_LOOP_COUNT
        },
    ];

    const playInfo3Items = [
        {
            'name': INPUT_KEY_SHOW_NAME_GOLD,
            'required' : false
        },
        {
            'name': INPUT_KEY_SHOW_NAME_CHARACTER_ON_MY_PAGE,
            'required' : false
        },
        {
            'name': INPUT_KEY_SHOW_NAME_FINALLY_USES_GOLD,
            'required' : false
        },
    ];

    const storeInfoItems = [
        {
            'placeHolder': 'クリスタル162個',
            'name': INPUT_KEY_SHOW_NAME_PAYMENT_INFO,
            'required' : true
        },
        {
            'placeHolder': '2023/3/5',
            'name': INPUT_KEY_SHOW_NAME_PAYMENT_DATE,
            'required' : true
        },
        {
            'placeHolder': 'GPA.1234-5678-9012-34567',
            'name': INPUT_KEY_SHOW_NAME_ORDER_NUMBER,
            'required' : true
        },
    ];

    // 基本情報の次のページを取得
    const getNextIndexOfBasicInfoIndex = computed(() => {
        if (getStoreInfo.value === STORE_GOOGLE) {
            return SEND_MAIL_INDEX
        }
        return PLAY_INFO1_INDEX;
    });

    // 入力内容のバリデーション後の次のページを取得
    const getNextIndexOfValidate = computed(() => {
        if (getStoreInfo.value === STORE_APPLE || getStoreInfo.value === STORE_AMAZON || getStoreInfo.value === STORE_OFFICIAL) {
            return APPLE_OR_AMAZON_CONFIRM_INDEX;
        }

        // 端末を持っている場合はメール送信画面へ
        if (isOwnDeviceValidate.value) {
            return SEND_MAIL_INDEX;
        }

        // ユーザーの基本情報が入力されていればメール送信画面へ
        if (isUserInfoValidate()) {
            return SEND_MAIL_INDEX;
        }
        
        // プレイ情報が規定数以上入力されていればメール送信画面へ
        if (isPlayInfoValidate()) {
            return SEND_MAIL_INDEX;
        }

        return REJECT_INDEX;
    });

    // ユーザーの基本情報が入力されているかチェック
    function isUserInfoValidate() {
        // ユーザー名、登録したメールアドレス、秘密の質問の答え（１つでも）が３つとも入力されていればOK
        return  validateInput(inputValues, INPUT_KEY_SHOW_NAME_NICK_NAME) &&
                validateInput(inputValues, INPUT_KEY_SHOW_NAME_EMAIL) &&
                validateAnyInput(inputValues, INPUT_KEY_SHOW_NAME_SECRET_ANSWER);
    }

    // ユーザーのプレイ情報が規定数以上入力されているかチェック
    function isPlayInfoValidate() {
        const VALIDATE_MATCH_COUNT = 3;

        let matchCount = 0;
        if (validateCharacter.value) matchCount++;
        if (validatePlayerName.value) matchCount++;
        if (validateGold.value) matchCount++;
        if (validateCharacterOnMyPage.value) matchCount++;
        if (validateFinallyUsesGold.value) matchCount++;
        if (validateDevice.value) matchCount++;

        if (matchCount >= VALIDATE_MATCH_COUNT) {
            return true;
        }
        return false;
    }

    // パスワードを覚えているかの質問でYESを回答時の次の質問
    const getNextIndexOfRememberPassWord = computed(() => {
        if (getRegistrationCase.value === REGISTRATION_SELECTION_EMAIL) {
            return SUPPORT_RECOVERY_EMAIL_INDEX;
        }
        else if (getRegistrationCase.value === REGISTRATION_SELECTION_GOOGLE) {
            return SUPPORT_RECOVERY_GOOGLE_INDEX;
        }
        return TOP_PAGE_INDEX;
    });
    // パスワードを覚えていない場合の次の質問
    const getNextIndexOfNotRememberPassWord = computed(() => {
        if (getRegistrationCase.value === REGISTRATION_SELECTION_EMAIL) {
            return IS_RECEIVE_EMAIL_INDEX;
        }
        else if (getRegistrationCase.value === REGISTRATION_SELECTION_GOOGLE) {
            return IS_PAY_INDEX;
        }
        return TOP_PAGE_INDEX;
    });

    // 課金履歴の質問で戻るボタンの遷移先
    const getPreviousIndexOfIsPay = computed(() => {
        // 登録方法が未登録の場合は登録方法のページに戻る
        if (getRegistrationCase.value === REGISTRATION_SELECTION_UNKNOWN) {
            return REGISTRATION_CASE_INDEX;
        }
        if (isUnReceivedValidate.value) {
            return IS_RECEIVE_EMAIL_INDEX;
        }
        if (isUnRememberPassWordValidate.value) {
            return IS_REMEMBER_PASSWORD_INDEX;
        }
        if (isUnRememberEmailValidate) {
            return IS_REMEMBER_EMAIL_INDEX;
        }

    });

    // 端末を持っているかの質問で戻るボタンの遷移先
    const getPreviousIndexOfIsOwnDevice = computed(() => {
        if (getIsPay.value === false) {
            return IS_PAY_INDEX;
        }

        if (getStoreInfo.value === STORE_OFFICIAL) {
            return BILLING_DETAIL_OFFICIAL_STORE_INDEX;
        }
        if (getStoreInfo.value === STORE_GOOGLE) {
            return BILLING_DETAIL_GOOGLE_INDEX;
        }
        if (getStoreInfo.value === STORE_APPLE) {
            return BILLING_DETAIL_APPLE_INDEX;
        }
        if (getStoreInfo.value === STORE_AMAZON) {
            return BILLING_DETAIL_AMAZON_INDEX;
        }
    });

    // カラム名が指定のカラムに一致するか
    // column + 数値の形式であればtrueを返す
    function isKeyMatchColumn(key, column) {
        return key.match(new RegExp(`^${column}\\d+$`));
    }

    // メール送信画面で戻るボタンの遷移先
    const getPreviousIndexOfSendMail = computed(() => {
        if (getIsPay.value === false) {
            return PLAY_INFO4_INDEX;
        }
        return BASIC_INFO2_INDEX;
    });
    function validateAllInput(inputValues, column, count) {
        let inputCount = 0;
        for (let key in inputValues.value) {
            if (!isKeyMatchColumn(key, column)) continue;
            inputCount++;
            // 一件でも未入力ならNG
            if(!inputValues.value[key]) {
                return false;
            }
        }
        return inputCount === count;
    }
    // キャラクターに関する情報が全て入力されているか
    const validateCharacter = computed(() => {
        return validateAllInput(inputValues, INPUT_KEY_SHOW_NAME_CHARACTER, CHARACTER_LOOP_COUNT);
    });
    // プレイヤー名が入力されているか
    const validatePlayerName = computed(() => {
        return validateAllInput(inputValues, INPUT_KEY_SHOW_NAME_PLAYER_NAME, PLAYER_NAME_LOOP_COUNT);
    });
    
    // 情報が１件でも入っていればtrueを返す
    function validateAnyInput(inputValues, column) {
        for (let key in inputValues.value) {
            if (!isKeyMatchColumn(key, column)) continue;
            // 一件でも入力されていればOK
            if (inputValues.value[key]) {
                return true;
            }
        }
        return false;
    }

    
    function validateInput(inputValues, column) {
        if (!column in inputValues.value) {
            return false;
        }
        return !!inputValues.value[column];
    }
    // 利用端末の入力の有無
    const validateDevice = computed(() => {
        return validateInput(inputValues, LAST_PLAY_DEVICE_TEXT);
    });
    // 所持クリスタル数の入力の有無
    const validateGold = computed(() => {
        return validateInput(inputValues, INPUT_KEY_SHOW_NAME_GOLD);
    });
    // マイページに設定しているカード名の入力の有無
    const validateCharacterOnMyPage = computed(() => {
        return validateInput(inputValues, INPUT_KEY_SHOW_NAME_CHARACTER_ON_MY_PAGE);
    });
    // 最後にクリスタルを消費した際の用途の入力の有無
    const validateFinallyUsesGold = computed(() => {
        return validateInput(inputValues, INPUT_KEY_SHOW_NAME_FINALLY_USES_GOLD);
    });
    // 登録時のメールアドレスを覚えていないか
    const isUnRememberEmailValidate = computed(() => {
        if (!IS_REMEMBER_EMAIL_TEXT in inputValues) {
            return false;
        }
        return inputValues.value[IS_REMEMBER_EMAIL_TEXT] === NO_TEXT;
    });

    // パスワードを覚えていないか
    const isUnRememberPassWordValidate = computed(() => {
        if (!IS_REMEMBER_PASSWORD_TEXT in inputValues) {
            return false;
        }
        return inputValues.value[IS_REMEMBER_PASSWORD_TEXT] === NO_TEXT;
    });

    // メールを受け取れないか
    const isUnReceivedValidate = computed(() => {
        if (!IS_RECEIVE_EMAIL_TEXT in inputValues) {
            return false;
        }
        return inputValues.value[IS_RECEIVE_EMAIL_TEXT] === NO_TEXT;
    });

    // 端末を持っているか
    const isOwnDeviceValidate = computed(() => {
        if (!IS_OWN_DEVICE_TEXT in inputValues.value) {
            return false;
        }
        return inputValues.value[IS_OWN_DEVICE_TEXT] === YES_TEXT;
    });

    // 課金したか
    const getIsPay = computed(() => {
        if (!IS_PAY_TEXT in inputValues.value) {
            return false;
        }
        return inputValues.value[IS_PAY_TEXT] === YES_TEXT;
    });

    // どのストアで課金したか
    const getStoreInfo = computed(() => {
        if (!STORE_INFO_TEXT in inputValues.value) {
            return null;
        }
        return inputValues.value[STORE_INFO_TEXT];
    });

    // 登録方法
    const getRegistrationCase = computed(() => {
        if (!REGISTRATION_CASE_TEXT in inputValues.value) {
            return null;
        }
        return inputValues.value[REGISTRATION_CASE_TEXT];
    });

    // ここから各フォームのページ情報を定義
    const isLoginPage =  {
        title: IS_LOGIN_PAGE_TEXT,
        message: null,
        component: SelectFormComponent,
        image: null,
        selections: [
            {
                'text' : YES_TEXT,
                'index' : ref(CONTACT_FROM_GAME_INDEX)
            },
            {
                'text' : NO_TEXT,
                'index' : ref(REGISTRATION_CASE_INDEX),
            }
        ],
        previousIndex: ref(TOP_PAGE_INDEX)
    };
    // ゲームからお問い合わせするように誘導
    const contactFromGame = {
        title: CONTACT_FROM_GAME_TEXT,
        message: null,
        component: SelectFormComponent,
        image: '/static/web/img/magicianwiz/how_to_contact.png',
        selections: [],
        isTopReturn: true,
        previousIndex: ref(IS_LOGIN_PAGE_INDEX)
    }
    // アカウントの登録方法
    const registrationCase = {
        title: REGISTRATION_CASE_TEXT,
        message: "",
        component: SelectFormComponent,
        image: null,
        selections: [
            {
                'text' : REGISTRATION_SELECTION_EMAIL,
                'index' : ref(IS_REMEMBER_EMAIL_INDEX),
            },
            {
                'text' : REGISTRATION_SELECTION_GOOGLE,
                'index' : ref(IS_REMEMBER_EMAIL_INDEX),
            },
            {
                'text' : REGISTRATION_SELECTION_APPLE,
                'index' : ref(SUPPORT_RECOVERY_APPLE_INDEX),
            },
            {
                'text' : REGISTRATION_SELECTION_UNKNOWN,
                'index' : ref(IS_PAY_INDEX),
            }
        ],
        previousIndex: ref(IS_LOGIN_PAGE_INDEX),
    }
    // メールアドレスを覚えているか
    const isRememberEmail = {
        title: IS_REMEMBER_EMAIL_TEXT,
        message: null,
        component: SelectFormComponent,
        image: null,
        selections: [
            {
                'text' : YES_TEXT,
                'index' : ref(IS_REMEMBER_PASSWORD_INDEX),
            },
            {
                'text' : NO_TEXT,
                'index' : ref(IS_PAY_INDEX),
            }
        ],
        previousIndex: ref(REGISTRATION_CASE_INDEX)
    }

    // パスワードを覚えているか
    const isRememberEmailPassword = {
        title: IS_REMEMBER_PASSWORD_TEXT,
        message: null,
        component: SelectFormComponent,
        image: null,
        selections: [
            {
                'text': YES_TEXT,
                'index': getNextIndexOfRememberPassWord,
            },
            {
                'text': NO_TEXT,
                'index': getNextIndexOfNotRememberPassWord,
            }
        ],
        previousIndex: IS_REMEMBER_EMAIL_INDEX
    };

    // メールアドレス登録の場合の誘導
    const supportHowToRecoveryForEmail = {
        title: SUPPORT_HOW_TO_RECOVERY_TEXT,
        message: null,
        component: SelectFormComponent,
        image: '/static/web/img/magicianwiz/support_recovery_account.png',
        selections: [],
        isTopReturn: true,
        previousIndex: ref(IS_REMEMBER_PASSWORD_INDEX)
    }
    // googleアカウントでの登録の場合の誘導
    const supportHowToRecoveryForGoogle = {
        title: SUPPORT_HOW_TO_RECOVERY_TEXT,
        message: null,
        component: SelectFormComponent,
        image: '/static/web/img/magicianwiz/support_recovery_google.png',
        selections: [],
        isTopReturn: true,
        previousIndex: ref(IS_REMEMBER_PASSWORD_INDEX)
    }
    // appleでの登録の場合の誘導
    const supportHowToRecoveryForApple = {
        title: SUPPORT_HOW_TO_RECOVERY_TEXT,
        message: null,
        component: SelectFormComponent,
        image: '/static/web/img/magicianwiz/support_recovery_siwa.png',
        selections: [],
        isTopReturn: true,
        previousIndex: ref(REGISTRATION_CASE_INDEX)
    }

    // lineでの登録の場合の誘導
    const supportHowToRecoveryForLine = {
        title: SUPPORT_HOW_TO_RECOVERY_TEXT,
        message: null,
        component: SelectFormComponent,
        image: '/static/web/img/magicianwiz/support_recovery_line.png',
        selections: [],
        isTopReturn: true,
        previousIndex: ref(REGISTRATION_CASE_INDEX)
    }
    // facebookでの登録の場合の誘導
    const supportHowToRecoveryForFB = {
        title: SUPPORT_HOW_TO_RECOVERY_TEXT,
        message: null,
        component: SelectFormComponent,
        image: '/static/web/img/magicianwiz/support_recovery_facebook.png',
        selections: [],
        isTopReturn: true,
        previousIndex: ref(REGISTRATION_CASE_INDEX)
    }

    // メールを受け取れるか
    const isReceiveEmail = {
        title: IS_RECEIVE_EMAIL_TEXT,
        message: null,
        component: SelectFormComponent,
        image: null,
        selections: [
            {
                'text' : YES_TEXT,
                'index' : ref(SUPPORT_RECOVERY_PASSWORD_REISSUE_INDEX),
            },
            {
                'text' : NO_TEXT,
                'index' : ref(IS_PAY_INDEX),
            }
        ],
        previousIndex: ref(IS_REMEMBER_PASSWORD_INDEX)
    }

    // パスワード再発行詠の誘導
    const passwordReissue = {
        title: PASSWORD_REISSUE_TEXT,
        message: null,
        component: ReissueComponent,
        image: null,
        selections: [],
        isTopReturn: true,
        previousIndex: ref(IS_RECEIVE_EMAIL_INDEX)
    }

    // 課金したことがあるか
    const isPay = {
        title: IS_PAY_TEXT,
        message: null,
        component: SelectFormComponent,
        image: null,
        selections: [
            {
                'text' : YES_TEXT,
                'index' : ref(STORE_INFO_INDEX),
            },
            {
                'text' : NO_TEXT,
                'index' : ref(IS_OWN_DEVICE_INDEX),
            }
        ],
        previousIndex: getPreviousIndexOfIsPay
    }

    // 端末を持っているか
    const isOwnDevice = {
        title: IS_OWN_DEVICE_TEXT,
        message: null,
        component: SelectFormComponent,
        image: null,
        selections: [
            {
                'text' : YES_TEXT,
                'index' : ref(BASIC_INFO1_INDEX),
            },
            {
                'text' : NO_TEXT,
                'index' : ref(BASIC_INFO1_INDEX),
            }
        ],
        previousIndex: getPreviousIndexOfIsOwnDevice
    }
    // 基本情報
    const basicInfo1 = {
        title: BASIC_INFO_TEXT,
        message: null,
        component: FreeTextComponent,
        image: null,
        selections: [],
        items: basicInfo1Items,
        nextIndex: ref(BASIC_INFO2_INDEX),
        previousIndex: ref(IS_OWN_DEVICE_INDEX)
    }
    const basicInfo2 = {
        title: BASIC_INFO_TEXT,
        message: null,
        component: FreeTextComponent,
        image: null,
        selections: [],
        items: basicInfo2Items,
        nextIndex: getNextIndexOfBasicInfoIndex,
        previousIndex: ref(BASIC_INFO1_INDEX)
    }

    // プレイ状況
    const playInfo1 = {
        title: PLAY_INFO_TEXT,
        message: PLAY_INFO1_MESSAGE,
        component: FreeTextComponent,
        image: null,
        selections: [],
        direction: 'row',
        items: playInfo1Items,
        nextIndex: ref(PLAY_INFO2_INDEX),
        previousIndex: ref(BASIC_INFO2_INDEX)

    }

    const playInfo2 = {
        title: PLAY_INFO_TEXT,
        message:PLAY_INFO2_MESSAGE,
        component: FreeTextComponent,
        image: null,
        selections: [],
        items: playInfo2Items,
        nextIndex:ref(PLAY_INFO3_INDEX),
        previousIndex: ref(PLAY_INFO1_INDEX)

    }
    const playInfo3 = {
        title: PLAY_INFO_TEXT,
        message: null,
        component: FreeTextComponent,
        image: null,
        selections: [],
        items: playInfo3Items,
        nextIndex: ref(PLAY_INFO4_INDEX),
        previousIndex: ref(PLAY_INFO2_INDEX)

    }
    const playInfo4 = {
        title: PLAY_INFO_TEXT,
        message: null,
        component: FreeTextComponent,
        image: null,
        selections: [],
        items: [{
            'name' : INPUT_KEY_SHOW_NAME_DEVICE,
            'placeHolder' : 'iPhone 14pro / Galaxy S23'
        }],
        nextIndex: getNextIndexOfValidate,
        previousIndex: ref(PLAY_INFO3_INDEX)

    }

    // 課金情報を含む場合の事前確認
    const confirmWithBilling = {
        title: SEND_MAIL_TEXT,
        message: null,
        component: SendComponent,
        image: null,
        selections: [{
            'text' : CONTINUE_TEXT,
            'index' : ref(APPLE_OR_AMAZON_SEND_MAIL_INDEX),
        }],
        items: [],
        previousIndex: ref(PLAY_INFO4_INDEX)
    }
    // 課金情報を含む場合のメール送信
    const sendWithBillingDetailSupport = {
        title: null,
        message: AMAZON_OR_APPLE_SEND_TEXT,
        itemPurchaseDetails: ITEM_PURCHASE_DETAILS,
        component: SendWithBillingDetailSupportComponent,
        showConfirm: false,
        image: null,
        selections: [],
        items: [],
        previousIndex: ref(APPLE_OR_AMAZON_CONFIRM_INDEX)
    }

    // メール送信
    const sendMail = {
        title: SEND_MAIL_TEXT,
        message: null,
        component: SendComponent,
        image: null,
        selections: [],
        items: [],
        previousIndex: getPreviousIndexOfSendMail
    }

    // どこで課金したか
    const storeInfo = {
        title: STORE_INFO_TEXT,
        message: null,
        component: SelectFormComponent,
        image: null,
        selections: [
            {
                'text' : STORE_OFFICIAL,
                'index' : ref(BILLING_DETAIL_OFFICIAL_STORE_INDEX)
            },
            {
                'text' : STORE_APPLE,
                'index' : ref(BILLING_DETAIL_APPLE_INDEX)
            },
            {
                'text' : STORE_AMAZON,
                'index' : ref(BILLING_DETAIL_AMAZON_INDEX),
            },
            {
                'text' : STORE_GOOGLE,
                'index' : ref(BILLING_DETAIL_GOOGLE_INDEX),
            },
        ],
        items: [],
        previousIndex: ref(IS_PAY_INDEX)
    }

    // 公式ストアでの課金詳細
    const billingDetailOfficialStore = {
        title: BILLING_NOTICE_TEXT,
        message: BILLING_DETAIL_OFFICIAL_STORE_HTML,
        component: SelectFormComponent,
        image: null,
        selections: [],
        items: [],
        previousIndex: ref(STORE_INFO_INDEX),
        nextIndex: ref(IS_OWN_DEVICE_INDEX),
        isRecordAnswer: false,
    }
    // appleでの課金詳細
    const billingDetailApple = {
        title: BILLING_NOTICE_TEXT,
        message: BILLING_DETAIL_APPLE_HTML,
        component: SelectFormComponent,
        image: null,
        selections: [],
        items: [],
        previousIndex: ref(STORE_INFO_INDEX),
        nextIndex: ref(IS_OWN_DEVICE_INDEX),
        isRecordAnswer: false,
    }
    // amazonでの課金詳細
    const billingDetailAmazon = {
        title: BILLING_NOTICE_TEXT,
        message: BILLING_DETAIL_AMAZON_HTML,
        component: SelectFormComponent,
        image: null,
        selections: [],
        items: [],
        previousIndex: ref(STORE_INFO_INDEX),
        nextIndex: ref(IS_OWN_DEVICE_INDEX),
        isRecordAnswer: false,
    }
    // googleでの課金詳細
    const billingDetailGoogle = {
        title: BILLING_DETAIL_TEXT,
        message: null,
        component: FreeTextComponent,
        image: null,
        selections: [{
            'text' : CONTINUE_TEXT,
            'index' : IS_OWN_DEVICE_INDEX
        }],
        items: storeInfoItems,
        nextIndex: ref(IS_OWN_DEVICE_INDEX),
        previousIndex: ref(STORE_INFO_INDEX)
    }
    // お断り
    const reject = {
        title: null,
        message: REJECT_MESSAGE,
        component: RejectComponent,
        image: null,
        selections: [],
        isTopReturn: true,
        previousIndex: ref(PLAY_INFO4_INDEX)
    }

    const pageInfoMap = {
            [TOP_PAGE_INDEX]: null,
            [IS_LOGIN_PAGE_INDEX]: isLoginPage, //ログインできるか
            [CONTACT_FROM_GAME_INDEX]: contactFromGame, // ログインできないので、ゲームからお問い合わせの案内
            [REGISTRATION_CASE_INDEX]: registrationCase, // 登録方法
            [IS_REMEMBER_EMAIL_INDEX]: isRememberEmail, // メールアドレスを覚えているか
            [IS_REMEMBER_PASSWORD_INDEX]: isRememberEmailPassword, // PWを覚えているか
            [IS_RECEIVE_EMAIL_INDEX]: isReceiveEmail, // メールアドレスを受信できるか
            [SUPPORT_RECOVERY_EMAIL_INDEX] : supportHowToRecoveryForEmail, // 引継ぎ方法(メアド)
            [SUPPORT_RECOVERY_GOOGLE_INDEX] : supportHowToRecoveryForGoogle, // 引継ぎ方法(Google)
            [SUPPORT_RECOVERY_APPLE_INDEX] : supportHowToRecoveryForApple, // 引継ぎ方法(Apple)
            [SUPPORT_RECOVERY_LINE_INDEX] : supportHowToRecoveryForLine, // 引継ぎ方法(LINE)
            [SUPPORT_RECOVERY_FACEBOOK_INDEX]: supportHowToRecoveryForFB, // 引継ぎ方法(FaceBook)
            [SUPPORT_RECOVERY_PASSWORD_REISSUE_INDEX]: passwordReissue, // パスワード再発行
            [IS_PAY_INDEX]: isPay, // 課金について
            [STORE_INFO_INDEX]: storeInfo, // どこで課金したか
            [IS_OWN_DEVICE_INDEX]: isOwnDevice, // 端末を持っているか
            [BILLING_DETAIL_OFFICIAL_STORE_INDEX]: billingDetailOfficialStore, // 公式ストアでの課金詳細
            [BILLING_DETAIL_APPLE_INDEX]: billingDetailApple, // appleでの課金詳細,
            [BILLING_DETAIL_AMAZON_INDEX]: billingDetailAmazon, // amazonでの課金詳細
            [BILLING_DETAIL_GOOGLE_INDEX]: billingDetailGoogle, // googleでの課金詳細
            [BASIC_INFO1_INDEX]: basicInfo1, // 基本情報1
            [BASIC_INFO2_INDEX]: basicInfo2, // 基本情報2
            [APPLE_OR_AMAZON_CONFIRM_INDEX]: confirmWithBilling, // 課金情報を含む場合の事前確認
            [APPLE_OR_AMAZON_SEND_MAIL_INDEX]: sendWithBillingDetailSupport, // 課金情報を含む場合のメール送信
            [SEND_MAIL_INDEX]: sendMail, // メール送信
            [PLAY_INFO1_INDEX]: playInfo1, // プレイ情報1
            [PLAY_INFO2_INDEX]: playInfo2, // プレイ情報2
            [PLAY_INFO3_INDEX]: playInfo3, // プレイ情報3
            [PLAY_INFO4_INDEX]: playInfo4, // プレイ情報4
            [REJECT_INDEX]: reject // お断り
    }
    // 現在のフォームのページ情報
    const currentPageInfo = computed(() => {
        if (!index.value in pageInfoMap) {
            return null;
        }
        return pageInfoMap[index.value];
    });
    const isGooglePlayPayInfoPage = computed(() =>  {
        return index.value === BILLING_DETAIL_GOOGLE_INDEX;
    });

    // Form.vueで扱う変数を返す
    return {
        currentPageInfo: currentPageInfo,
        pageInfoMap: pageInfoMap,
        isGooglePlayPayInfoPage: isGooglePlayPayInfoPage,
        BILLING_DETAIL_APPLE_HTML: BILLING_DETAIL_APPLE_HTML,
        BILLING_DETAIL_AMAZON_HTML: BILLING_DETAIL_AMAZON_HTML,
        PLAY_INFO1_INDEX: PLAY_INFO1_INDEX,
        REISSUE_MAIL_ADDRESS: REISSUE_MAIL_ADDRESS,
        CONTACT_MAIL_ADDRESS: CONTACT_MAIL_ADDRESS,
        PROJECT_NAME: PROJECT_NAME,
    };

}